import keyMirror from 'keymirror'

export const STATUS_DRAFT = 'draft'
export const STATUS_PUBLISH = 'publish'

export const statuses = keyMirror({
  STATUS_DRAFT: null,
  STATUS_PUBLISH: null,
})
